/**
 * Dependency resolver for @fishx/remote-component.
 * Maps each external package (as declared in promotionRemotePBh5/fishx.config.ts externals)
 * to its runtime module so remote components can share dependencies with the host app.
 */
const react = require('react');
const reactDom = require('react-dom');
const moment = require('moment');
const reactColor = require('react-color');
const classnames = require('classnames');

module.exports = {
  resolve: {
    react: () => react,
    'react-dom': () => reactDom,
    moment: () => moment,
    'react-color': () => reactColor,
    classnames: () => classnames,
  },
};
